import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { ChartContainer, ChartTooltip, ChartTooltipContent } from '@/components/ui/chart';
import { UsersIcon } from 'lucide-react';
import { Area, AreaChart, CartesianGrid, XAxis, YAxis } from 'recharts';

interface ClientsChartProps {
	data: { label: string; count: number }[];
	title?: string;
}

const chartConfig = {
	count: { label: 'Клиенты', color: 'var(--chart-2)' },
};

export default function ClientsChart({ data, title = 'Клиенты' }: ClientsChartProps) {
	const hasData = data.some(d => d.count > 0);

	return (
		<Card className='gap-0 py-0 shadow-sm overflow-hidden'>
			<CardHeader className='border-b px-4 py-3'>
				<div className='flex items-center gap-2'>
					<div className='rounded-lg bg-chart-2/15 p-1.5'>
						<UsersIcon className='text-chart-2' size={16} />
					</div>
					<CardTitle className='text-sm'>{title}</CardTitle>
				</div>
			</CardHeader>
			<CardContent className='px-2 py-3'>
				{!hasData ? (
					<div className='h-[180px] flex items-center justify-center text-sm text-muted-foreground'>Нет данных</div>
				) : (
					<ChartContainer config={chartConfig} className='h-[180px] w-full'>
						<AreaChart data={data} margin={{ top: 8, right: 8, left: -20, bottom: 0 }}>
							<CartesianGrid strokeDasharray='3 3' vertical={false} />
							<XAxis dataKey='label' tickLine={false} axisLine={false} tick={{ fontSize: 10 }} interval='preserveStartEnd' />
							<YAxis tickLine={false} axisLine={false} tick={{ fontSize: 10 }} allowDecimals={false} />
							<ChartTooltip content={<ChartTooltipContent />} />
							<Area type='monotone' dataKey='count' stroke='var(--chart-2)' fill='var(--chart-2)' fillOpacity={0.2} strokeWidth={2} />
						</AreaChart>
					</ChartContainer>
				)}
			</CardContent>
		</Card>
	);
}
